export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Regular.b36a2f23d455292a6ed716a3625c686e.woff2";